@import '../../../globals/main';

pn-quote-card {
  .pn-quote-card__section {
  }

  .pn-quote-card__container {
    margin: 0 auto;
    display: flex;
    flex-direction: row;

    min-height: 262px;
    padding: 0 2.4rem;
  }

  .pn-quote-card__quote__container {
    padding: 0 3.2rem;
  }

  .pn-quote-card__quote {
    position: relative;
    font-weight: 400;
    font-size: 2rem;
    line-height: 140%;
    margin: 0;

    svg {
      position: absolute;
      left: -3.2rem;
      top: 0.2rem;
    }
  }

  .pn-quote-card__reference__container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 1.6rem;

    align-items: center;
  }

  .pn-quote-card__reference {
  }

  .pn-quote-card__reference__name {
    display: block;
    font-weight: 400;
    font-size: 2.4rem;
    line-height: 2.9rem;
  }

  .pn-quote-card__reference__occupation {
    display: block;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 1.7rem;
  }

  [slot='illustration'] {
    padding: 0;
  }

  [slot='illustration-big'] {
    padding: 0.8rem 0;
  }

  [slot='illustration'],
  [slot='illustration-big'] {
    aspect-ratio: 1/1;

    picture {
      aspect-ratio: 1 / 1;
      img {
        clip-path: circle(50%);
        max-width: unset;
      }
    }
  }
}

//line orientation

pn-quote-card {
  [slot='horizontal-line'],
  [slot='vertical-line'] {
    display: flex;
  }
}

//Colors
pn-quote-card[data-line-color='white'] {
  .pn-quote-card__section {
    background-color: $blue700;
    color: $white;
  }

  .pn-line-shape__line,
  .pn-line-shape__dot {
    border-color: $white;
    background-color: $white;
  }

  .pn-quote-card__quote {
    svg > path {
      fill: $white;
    }
  }
}

pn-quote-card[data-line-color='blue'] {
  .pn-quote-card__section {
    background-color: $white;
  }

  .pn-line-shape__line,
  .pn-line-shape__dot {
    border-color: $blue400;
    background-color: $blue400;
  }

  .pn-quote-card__quote {
    svg > path {
      fill: $blue400;
    }
  }
}

pn-quote-card[data-line-color='blue900'] {
  .pn-quote-card__section {
    background-color: $white;
  }

  .pn-line-shape__line,
  .pn-line-shape__dot {
    border-color: $blue900;
    background-color: $blue900;
  }

  .pn-quote-card__quote {
    svg > path {
      fill: $blue900;
    }
  }
}

//layouts

pn-quote-card[data-card-style='standalone'] {
  &[data-line-color='white'] {
    .pn-quote-card__section {
      border-radius: 2.4rem;
    }

    .pn-quote-card__container {
      padding: 2.4rem;
    }
  }
  .pn-quote-card__section {
    max-width: 100%;
    margin: 0 auto;

    @media screen and (min-width: $min-width-lg) {
      max-width: 70%;
    }
    @media screen and (min-width: $min-width-xl) {
      max-width: 60%;
    }
  }

  .pn-quote-card__container {
    min-height: unset;
    padding: 0;

    @media screen and (min-width: $min-width-md) {
      padding: 0 2.4rem;
    }
  }

  .pn-quote-card__quote__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 3.2rem;
    padding: 2.4rem 1.6rem 1.6rem 1.6rem;

    @media screen and (min-width: $min-width-md) {
      padding: 2.4rem 3.2rem 1.6rem 3.2rem;
    }
  }

  .pn-quote-card__quote {
    font-size: 1.6rem;

    @media screen and (min-width: $min-width-lg) {
      font-size: 2rem;
    }

    svg {
      display: block;
      margin-bottom: 0.8rem;
      position: relative;
      top: 0;
      left: 0;
    }
  }

  .pn-quote-card__reference__container {
    [slot='illustration'] {
      picture {
        img {
          height: 6rem;
          width: 6rem;
        }
      }
    }
    @media screen and (min-width: $min-width-lg) {
      [slot='illustration'] {
        picture {
          img {
            height: 9rem;
            width: 9rem;
          }
        }
      }
    }
  }

  .pn-quote-card__reference__name {
    font-size: 1.6rem;
    @media screen and (min-width: $min-width-lg) {
      font-size: 2.4rem;
    }
  }

  .pn-quote-card__reference__occupation {
    font-size: 1.2rem;
    @media screen and (min-width: $min-width-lg) {
      font-size: 1.4rem;
    }
  }

  .pn-quote-card__large-photo {
    display: none;
  }
}

pn-quote-card[data-card-style='combo'] {
  .pn-quote-card__section {
    width: 100%;
    margin: 0 auto;
    padding-top: 4rem;
    padding-bottom: 4rem;
    @media screen and (min-width: $min-width-lg) {
      padding-bottom: 0;
    }

    @media screen and (min-width: $min-width-xl) {
      padding-top: 10rem;
    }
  }

  .pn-quote-card__container {
    min-height: 10rem;
    padding-bottom: 0;

    @media screen and (min-width: $min-width-md) {
      max-width: 90%;
      width: 100%;
    }

    @media screen and (min-width: $min-width-lg) {
      max-width: $min-width-md;
      width: 100%;
    }
    @media screen and (min-width: $min-width-xl) {
      max-width: $max-width-xl;
      width: 100%;
      padding: 0 5.6rem;
    }
    @media screen and (min-width: $min-width-xxl) {
      max-width: $max-width-xxl;
      width: 100%;
      padding: 0 12rem;
    }
  }

  .pn-quote-card__quote__container {
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;

    @media screen and (min-width: $min-width-md) {
      padding-left: 2.4rem;
      padding-right: 2.4rem;
    }
  }

  .pn-quote-card__quote {
    font-size: 2rem;
    padding-left: 2.4rem;
    svg {
      left: -0.8rem;
      top: 0.2rem;
    }

    @media screen and (min-width: $min-width-md) {
      padding-left: 4rem;
      svg {
        left: 0;
      }
    }

    @media screen and (min-width: $min-width-lg) {
      font-size: 2.4rem;
      svg {
        left: 0;
        top: 0.4rem;
        scale: 1.3;
      }
    }

    @media screen and (min-width: $min-width-xl) {
      padding-left: 0;
      font-size: 3.2rem;
      svg {
        left: -4.8rem;
        top: 1rem;
        scale: 1.4;
      }
    }

    @media screen and (min-width: $min-width-xxl) {
      font-size: 3.8rem;
      svg {
        left: -6.4rem;
        top: 1.6rem;
        scale: 1.8;
      }
    }
  }

  .pn-quote-card__reference__container {
    flex-direction: row-reverse;
  }

  [slot='illustration'] {
    picture > img {
      max-width: 6rem;
      max-height: 6rem;
    }

    @media screen and (min-width: $min-width-md) {
      picture > img {
        max-width: 10rem;
        max-height: 10rem;
      }
    }

    @media screen and (min-width: $max-width-xl) {
      display: none;
    }
  }

  .pn-quote-card__reference {
    text-align: right;
  }

  .pn-quote-card__reference__name {
    display: block;
    font-size: 1.4rem;
    @media screen and (min-width: $min-width-md) {
      font-size: 1.6rem;
    }

    @media screen and (min-width: $min-width-lg) {
      font-size: 2rem;
    }

    @media screen and (min-width: $min-width-xxl) {
      font-size: 3.2rem;
      margin-bottom: 1rem;
    }
  }

  .pn-quote-card__reference__occupation {
    display: block;

    font-size: 1.2rem;
    @media screen and (min-width: $min-width-lg) {
      font-size: 1.4rem;
    }

    @media screen and (min-width: $min-width-xxl) {
      font-size: 1.6rem;
    }
  }

  .pn-quote-card__large-photo {
    display: none;

    @media screen and (min-width: $max-width-xl) {
      display: block;

      & > [slot='illustration-big'] {
        width: 18rem;
        height: 18rem;
        & picture > img {
          width: 18rem;
          height: 18rem;
        }
      }
    }

    @media screen and (min-width: $min-width-xxl) {
      display: block;
      width: 24rem;
      height: 24rem;
      & > [slot='illustration-big'] {
        position: relative;
        z-index: 1;
        width: 24rem;
        height: 24rem;

        & > picture > img {
          width: 24rem;
          height: 24rem;
        }
      }
    }
  }
}
